import React, { type ReactElement } from 'react';

export const TipEpubContent = (): ReactElement => (
    <div>
        <span>Читайте книги когда удобно.</span>
        <br />
        <span>Облако запомнит, где вы остановились.</span>
    </div>
);
